import { defineMessages } from '@transcend-io/internationalization';

export const inlineConfirmMessages = defineMessages(
  'pc-core-components.InlineConfirm.inlineConfirm',
  {
    no: {
      defaultMessage: 'No',
    },
    yes: {
      defaultMessage: 'Yes',
    },
  },
);
